import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d61e546&"
import script from "./boxchatting.js?vue&type=script&lang=js&"
export * from "./boxchatting.js?vue&type=script&lang=js&"
import style0 from "../../../views/ChatView/chatview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports